import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ProjectModel } from '@project/model/project.model';
import { truncate } from 'lodash';
import { AdminToolService } from '@admintool/services/admintool.service';
import { distinctUntilChanged, map, startWith } from 'rxjs/operators';
import { combineLatest } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TabTitleService {

  constructor(
    private titleService: Title,
    private projectModel: ProjectModel,
    private adminToolService: AdminToolService,
  ) {}

  initialize() {

    const projectName$ = this.projectModel.projectChanged$.pipe(
      map(change => change.projectHeadVO?.name),
      distinctUntilChanged(),
      startWith(undefined)
    )

    const articleNo$ = this.adminToolService.articleNoLoaded$.pipe(startWith(undefined));

    combineLatest([projectName$, articleNo$]).subscribe(([projectName, articleNo]) => {
      let tabTitle = "WAGO Smart Designer"
      if (projectName || articleNo) {
        tabTitle = `${truncate(articleNo || projectName || '', { length: 32 })} | ${tabTitle}`;
      }
      this.titleService.setTitle(tabTitle);
    });
  }
}
